import React, { useState } from "react";
import { Popover } from "antd";
import { Icon3Dots } from "../Layout/Icons";
import ImumProductTagPopoverShow from "./ImumProductTagPopoverShow";
import ImumProductTagManagerPreview from "./ImumProductTagManagerPreview";

const ImumProductTagPopover = ({
  product_id,
  imum_product_tags,
  tag_ids,
  context,
}) => {
  // initialTags => tag_ids
  const [open, setOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="mx-1">
      <Popover
        overlayStyle={{
          maxWidth: 200,
        }}
        overlayClassName="popover-without-padding"
        placement="right"
        content={
          open ? (
            <ImumProductTagPopoverShow
              product_id={product_id}
              tag_ids={tag_ids}
              imum_product_tags={imum_product_tags}
              context={context}
              openManager={() => {
                setOpen(false);
                setShowModal(true);
              }}
            />
          ) : (
            ""
          )
        }
        onOpenChange={(status) => {
          if (!status && open) setOpen(false);
        }}
        open={open}
        trigger="click"
      >
        <Icon3Dots
          className="cursor-pointer ml-1"
          onClick={() => {
            setOpen((prev) => !prev);
          }}
        />
      </Popover>
      {showModal && (
        <ImumProductTagManagerPreview
          initialTags={tag_ids}
          showModal={showModal}
          setShowModal={setShowModal}
          context={context}
        />
      )}
    </div>
  );
};

export default ImumProductTagPopover;
